/* @jsx h */
import { useBranding } from "@app/vue/providers/Branding";
import { useLocalization } from "@lemmonhq/uikit";
import { defineComponent, h } from "vue";

export const HeroSection = defineComponent({
  props: {
    cityName: {
      type: String,
      default: "your city",
    },
  },
  setup(props, { slots }) {
    const { branding } = useBranding();
    const { t } = useLocalization();
    return () => (
      <div
        class="relative overflow-hidden rounded my-2 "
        style="padding: clamp(48px, 6vw, 96px) 0 clamp(48px, 6vw, 80px); background-color: #f9f9f7; background-image: repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(0,0,0,0.04) 35px, rgba(0,0,0,0.04) 70px);"
      >
        {/* Subtle radial glow behind stripes */}
        <div
          class="absolute inset-0 pointer-events-none"
          style="background: radial-gradient(ellipse 60% 50% at 50% 40%, rgba(26,26,26,0.025) 0%, transparent 70%); z-index: 0;"
          aria-hidden="true"
        />

        <div
          class="relative max-w-4xl mx-auto text-center px-4"
          data-reveal
          style="z-index: 1;"
        >
          {/* Main Headline */}
          <h1
            class="text-3xl md:text-5xl font-bold tracking-tight text-gray-900 mb-4"
            style="letter-spacing: -0.02em; text-wrap: balance; line-height: 1.1;"
          >
            {branding.value?.id === "javshani" ? (
              <>
                {t("customer.home.hero_javshani_before")}{" "}
                <span class="italic font-light">
                  {t("customer.home.hero_tables")}
                </span>{" "}
                {t("customer.home.hero_and")}{" "}
                <span class="italic font-light">
                  {t("customer.home.hero_javshani_experiences")}
                </span>{" "}
                {t("customer.home.hero_in_one_space")}
              </>
            ) : (
              <>
                {t("customer.home.hero_default_before")}{" "}
                <span class="italic font-light">
                  {t("customer.home.hero_tables")}
                </span>{" "}
                {t("customer.home.hero_and")}{" "}
                <span class="italic font-light">
                  {t("customer.home.hero_experiences")}
                </span>{" "}
                {t("customer.home.hero_in_one_space")}
              </>
            )}
          </h1>

          {/* Subheading */}
          <p class="text-gray-500 font-light text-base md:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
            {branding.value?.id === "javshani"
              ? t("customer.home.hero_javshani_subtitle_before")
              : t("customer.home.hero_subtitle_before")}{" "}
            <span class="font-bold text-gray-900 tracking-wide uppercase">
              {branding.value?.name}
            </span>
          </p>

          {/* Slot for city selector */}
          {slots.cityControl && (
            <div class="mb-6 flex justify-center">{slots.cityControl()}</div>
          )}

          {/* Slot for search bar */}
          {slots.default && (
            <div class="max-w-3xl mx-auto bg-white rounded-xl px-6 py-2 shadow-sm border border-gray-100">
              {slots.default()}
            </div>
          )}
        </div>
      </div>
    );
  },
});
